(function () {
  'use strict';

  var root = document.querySelector('[data-pooja-kit]');
  if (!root) return;

  var kitSize = parseInt(root.getAttribute('data-kit-size') || '5', 10);
  var kitPrice = parseInt(root.getAttribute('data-kit-price') || '0', 10);
  var kitCheckoutVariant = parseInt(root.getAttribute('data-kit-checkout-variant') || '0', 10);
  var slotsEl = root.querySelector('[data-kit-slots]');
  var statusEl = root.querySelector('[data-kit-status]');
  var atcButtons = root.querySelectorAll('[data-kit-atc]');
  var priceNowEl = root.querySelector('[data-kit-price-now]');
  var priceWasEl = root.querySelector('[data-kit-price-was]');
  var saveEl = root.querySelector('[data-kit-save]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kit-card]'));
  var progressEl = root.querySelector('[data-kit-progress]');
  var progressAnchor = root.querySelector('[data-kit-progress-anchor]');

  var kit = [];
  var buying = false;

  function money(cents) {
    var value = Math.max(0, Number(cents) || 0) / 100;
    var formatted = value.toLocaleString('en-IN', {
      minimumFractionDigits: value % 1 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
    return '₹' + formatted;
  }

  function remaining() {
    return Math.max(0, kitSize - kit.length);
  }

  function isReady() {
    return kit.length >= kitSize;
  }

  function originalTotal() {
    return kit.reduce(function (sum, item) {
      return sum + (Number(item.price) || 0);
    }, 0);
  }

  function escapeAttr(value) {
    return String(value || '').replace(/"/g, '&quot;');
  }

  function renderSlots() {
    if (!slotsEl) return;
    var html = '';
    var i;
    for (i = 0; i < kitSize; i += 1) {
      if (i > 0) {
        html +=
          '<span class="arthcart-kit__slot-line' +
          (kit[i] ? ' is-done' : '') +
          '" aria-hidden="true"><i></i></span>';
      }
      var item = kit[i];
      var num = String(i + 1);
      if (item) {
        html +=
          '<div class="arthcart-kit__slot is-filled">' +
          '<span class="arthcart-kit__slot-index">' +
          num +
          '</span>' +
          '<img src="' +
          item.image +
          '" alt="' +
          escapeAttr(item.title) +
          '">' +
          '<button type="button" class="arthcart-kit__slot-remove" data-kit-remove="' +
          i +
          '" aria-label="Remove">×</button>' +
          '</div>';
      } else {
        html +=
          '<div class="arthcart-kit__slot">' +
          '<span class="arthcart-kit__slot-index">' +
          num +
          '</span>' +
          '</div>';
      }
    }
    slotsEl.innerHTML = html;
  }

  function renderStatus() {
    if (!statusEl) return;
    var left = remaining();
    if (isReady()) {
      statusEl.textContent = 'Kit ready — ' + kitSize + ' products for ' + money(kitPrice);
    } else if (kit.length === 0) {
      statusEl.textContent = 'Add ' + kitSize + ' products to build your kit';
    } else {
      statusEl.textContent = left + ' more to add';
    }
  }

  function setBuyLabel(label) {
    atcButtons.forEach(function (btn) {
      btn.textContent = label;
    });
  }

  function renderTotals() {
    var original = originalTotal();
    var ready = isReady();
    var payable = ready ? kitPrice : original;
    var save = ready ? Math.max(0, original - kitPrice) : 0;

    if (priceNowEl) priceNowEl.textContent = money(payable);
    if (priceWasEl) {
      if (ready && original > kitPrice) {
        priceWasEl.textContent = money(original);
        priceWasEl.hidden = false;
      } else {
        priceWasEl.hidden = true;
      }
    }
    if (saveEl) {
      saveEl.textContent = 'Save: ' + money(save);
    }

    atcButtons.forEach(function (btn) {
      btn.disabled = !ready || buying;
      btn.classList.toggle('is-ready', ready);
      if (!buying) btn.textContent = 'Buy Now';
    });
  }

  function renderCards() {
    var handles = {};
    kit.forEach(function (item) {
      handles[item.handle] = true;
    });
    cards.forEach(function (card) {
      var handle = card.getAttribute('data-handle');
      var inKit = !!handles[handle];
      var full = isReady() && !inKit;
      card.classList.toggle('is-in-kit', inKit);
      var btn = card.querySelector('[data-kit-add]');
      if (!btn) return;
      btn.disabled = full;
      btn.textContent = inKit ? 'Added to kit' : 'Add to kit';
    });
  }

  function render() {
    renderSlots();
    renderStatus();
    renderTotals();
    renderCards();
    freezeProgress();
  }

  function addFromCard(card) {
    if (isReady()) return;
    var handle = card.getAttribute('data-handle');
    if (kit.some(function (item) { return item.handle === handle; })) return;

    kit.push({
      handle: handle,
      variantId: Number(card.getAttribute('data-variant-id')),
      title: card.getAttribute('data-title') || '',
      image: card.getAttribute('data-image') || '',
      price: Number(card.getAttribute('data-price') || 0)
    });
    render();
  }

  function removeAt(index) {
    kit.splice(index, 1);
    render();
  }

  function headerOffset() {
    var els = document.querySelectorAll(
      '.announcement-bar, sticky-header, sticky-header-mobile, .header-mobile, .header-navigation-wrapper'
    );
    var bottom = 0;
    Array.prototype.forEach.call(els, function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom > bottom) bottom = r.bottom;
    });
    return Math.max(0, Math.round(bottom));
  }

  function freezeProgress() {
    if (!progressEl || !progressAnchor) return;
    var header = headerOffset();
    var rect = progressAnchor.getBoundingClientRect();
    if (rect.top <= header) {
      if (!progressEl.classList.contains('is-frozen')) {
        progressAnchor.style.height = progressEl.offsetHeight + 'px';
        progressEl.classList.add('is-frozen');
      }
      progressEl.style.top = header + 'px';
    } else {
      progressEl.classList.remove('is-frozen');
      progressAnchor.style.height = '';
      progressEl.style.top = '';
    }
  }

  function kitProperties() {
    var props = {
      _kit: 'build-your-own-pooja-kit',
      Kit: 'Build your own puja kit (' + kitSize + ' for ₹999)'
    };
    kit.forEach(function (item, index) {
      var n = String(index + 1);
      props['Item ' + n] = item.title;
      props['_handle_' + n] = item.handle;
      props['_variant_' + n] = String(item.variantId);
    });
    props['_original'] = String(originalTotal());
    return props;
  }

  function kitItemsPayload() {
    var props = kitProperties();
    if (kitCheckoutVariant) {
      return [
        {
          id: kitCheckoutVariant,
          quantity: 1,
          properties: props
        }
      ];
    }
    return kit.map(function (item) {
      return {
        id: item.variantId,
        quantity: 1,
        properties: props
      };
    });
  }

  function normalizeMagicCartPayload(data) {
    if (data && Array.isArray(data.items)) return data;
    if (Array.isArray(data)) return { items: data };
    if (data) return { items: [data] };
    return { items: [] };
  }

  function addKitLines() {
    return fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin'
    })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: kitItemsPayload() })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cart failed');
        return res.json();
      })
      .then(normalizeMagicCartPayload);
  }

  window.customMagicAddToCart = function () {
    if (!isReady()) return Promise.reject(new Error('Pick 5 products first'));
    return addKitLines();
  };

  function resetBuying() {
    buying = false;
    renderTotals();
  }

  function magicUiPresent() {
    return !!document.querySelector(
      '.razorpay-container, .razorpay-checkout-frame, iframe[src*="razorpay"], [class*="magic-checkout"]'
    );
  }

  function clickHiddenMagic() {
    var el =
      root.querySelector('magic-checkout-btn') ||
      document.querySelector('magic-checkout-btn[page-type="cart"]') ||
      document.querySelector('magic-checkout-btn');
    if (!el) return false;
    try {
      el.click();
      return true;
    } catch (e) {
      return false;
    }
  }

  function buyKitNow() {
    if (!isReady() || buying) return;
    buying = true;
    setBuyLabel('Opening…');
    atcButtons.forEach(function (btn) {
      btn.disabled = true;
    });

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'rzp-magic-btn__buy-product';
    trigger.setAttribute('aria-hidden', 'true');
    trigger.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';
    document.body.appendChild(trigger);
    try {
      trigger.click();
    } catch (e) {}

    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (magicUiPresent()) {
        clearInterval(timer);
        if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
        resetBuying();
        return;
      }
      if (tries === 8) {
        addKitLines()
          .then(function () {
            clickHiddenMagic();
            try {
              trigger.click();
            } catch (e2) {}
          })
          .catch(function () {
            clearInterval(timer);
            if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
            resetBuying();
            window.alert('Could not start payment. Please try again.');
          });
      }
      if (tries >= 24) {
        clearInterval(timer);
        if (trigger.parentNode) trigger.parentNode.removeChild(trigger);
        resetBuying();
      }
    }, 200);
  }

  root.addEventListener('click', function (event) {
    var addBtn = event.target.closest('[data-kit-add]');
    if (addBtn) {
      event.preventDefault();
      addFromCard(addBtn.closest('[data-kit-card]'));
      return;
    }
    var removeBtn = event.target.closest('[data-kit-remove]');
    if (removeBtn) {
      event.preventDefault();
      removeAt(parseInt(removeBtn.getAttribute('data-kit-remove'), 10));
      return;
    }
    var atcBtn = event.target.closest('[data-kit-atc]');
    if (atcBtn) {
      event.preventDefault();
      buyKitNow();
    }
  });

  window.addEventListener('pageshow', resetBuying);
  window.addEventListener('pagehide', resetBuying);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') resetBuying();
  });
  window.addEventListener('scroll', freezeProgress, { passive: true });
  window.addEventListener('resize', freezeProgress);
  freezeProgress();
  render();
})();
